import Switch from 'app/components/Switch';
import { type ChatItemLocationResults } from 'app/services/chatBot';
import { ChangeEventHandler, useState } from 'react';

import BaseChatItem from '../BaseChatItem';
import LocationCard from './LocationCard';
import { isLocationBrandEducated } from './util';

const LocationResultsChatItem = ({ chatItem }: { chatItem: ChatItemLocationResults }) => {
  const [visibleItemCount, setVisibleItemCount] = useState(3);
  const [onlyEducatedResults, setOnlyEducatedResults] = useState(false);

  const handleShowMore = () => {
    setVisibleItemCount((vic) => vic + 3);
  };

  const handleChangeFilter: ChangeEventHandler<HTMLInputElement> = (event) => {
    setVisibleItemCount(3);
    setOnlyEducatedResults(event.target.checked);
  };

  const filterLabel = chatItem.filter_message;
  const disclaimerMessage = chatItem.disclaimer_message;

  const visibleLocations = onlyEducatedResults ? chatItem.items.filter(isLocationBrandEducated) : chatItem.items;

  return (
    <BaseChatItem showAvatar={false} isUserMessage={false}>
      <div className="flex flex-col gap-y-2 -ml-9">
        <label className="rounded-[4px] p-3 bg-[#F3F3F3] text-xs font-medium flex gap-4 items-center">
          <div className="flex flex-col gap-1 grow">
            {filterLabel}
            {disclaimerMessage && <span className="text-[#838383]">{disclaimerMessage}</span>}
          </div>
          <Switch
            checked={onlyEducatedResults}
            onChange={handleChangeFilter}
          />
        </label>
        {!visibleLocations.length && onlyEducatedResults && (
          <div className="p-2 text-xs text-center">No brand educated providers available</div>
        )}
        {visibleLocations.slice(0, visibleItemCount).map((location) => (
          <LocationCard
            key={location.place_id}
            location={location}
          />
        ))}
        {visibleItemCount < visibleLocations.length && (
          <button
            onClick={handleShowMore}
            className="text-sm leading-[18px]"
          >
            Show more
          </button>
        )}
      </div>
    </BaseChatItem>
  );
};

export default LocationResultsChatItem;
